<style lang="less" scoped>
    .btn-ct {
        text-align: center;
        color: #df9c3b;
        display: block;
        width: 1.06rem;
        height: 1.06rem;
        line-height: 1.06rem;
        font-size: .26rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -0.53rem;
        margin-left: -0.53rem;
        background: url("https://staticcdn-yy-prd.pydp888.com/award/kline/img/1.0/page_2.0_bg_ico.png?v=1.0.7") 50% 50% no-repeat;
        background-size: auto 100%;
    }

</style>

<template>
    <a v-if="allCount > 0" class="btn-ct" @click="click">
        <span v-if="isPlayedKid(curKid)" class="btn-ct__num">结果</span>
        <span v-else class="btn-ct__num">{{curOid}}/{{allCount}}</span>
    </a>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'
    export default {
        name: 'foot-button-center',
        computed: {
            ...mapGetters('reality', ['allCount', 'curOid', 'isPlayedKid', 'curKid'])
        },
        methods: {
            click() {
                this.$emit('click')
            }
        }
    };

</script>
